module.exports = __webpack_public_path__ + "static/logo_gradient-49c4a737b5a09c81f67e336963e776b4.svg";